// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

export const CategoryValues = new Set([
  'UNSET' as const,
  'PRO_TIP' as const,
  'ACTIVITY' as const,
  'VIEW' as const,
]);
export type Category = typeof CategoryValues extends Set<infer U> ? U : never;

